import styled from 'styled-components';

export const CheckAnswers = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;
export const AnswersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 90%;
  align-items: flex-start;
  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    width: 100%;
  }
`;
